import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import Loadable from 'ui-component/Loadable';
import MinimalLayout from 'layout/MinimalLayout';
// simple auth wrapper (duplicate of MainRoutes)
const RequireAuth = ({ children }) => {
    const token = localStorage.getItem('club-jwt');
    if (!token) {
        return <Navigate to="/pages/login/login3" replace />;
    }
    try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        if (payload.exp && payload.exp * 1000 < Date.now()) {
            localStorage.removeItem('club-jwt');
            return <Navigate to="/pages/login/login3" replace />;
        }
    } catch (err) {
        localStorage.removeItem('club-jwt');
        return <Navigate to="/pages/login/login3" replace />;
    }
    return children;
};

// project imports


// login option 3 routing
const DrawGameCalendarFullScreen = Loadable(lazy(() => import('views/gamePlanning/DrawGameCalendarFullScreen')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const MinimalLayoutRoutes = {
    path: '/',
    element: <RequireAuth><MinimalLayout /></RequireAuth>,
    children: [
        {
            path: 'views/drawGameLandarFullScreen',
            element: <DrawGameCalendarFullScreen />
        },
    ]
};

export default MinimalLayoutRoutes;
